type ChipType = {
  label: string;
  variant: "green" | "red" | "blue" | "yellow" | "grey" | "purple";
  className?: string;
  onClick?: () => void;
};

const Chip = (props: ChipType) => {
  const { label, variant = "green", className, onClick } = props;

  return (
    <span
      className={`theme-chip theme-chip-color-${variant} ${
        className && className
      }`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {label}
    </span>
  );
};

export default Chip;
